"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePageLifecycle = void 0;
const react_1 = require("react");
const consts_1 = require("./consts");
const enums_1 = require("./enums");
const utils_1 = require("./utils");
/**
 * Хук возвращает текущее состояние жизненного цикла страницы и признак была ли страница удалена из скрытой вкладки.
 */
const usePageLifecycle = () => {
    const [state, setState] = (0, react_1.useState)((0, utils_1.getCurrentState)());
    const stateRef = (0, react_1.useRef)(state);
    const changeState = (0, react_1.useCallback)((nextState) => {
        const prevState = stateRef.current;
        if (nextState !== prevState) {
            const path = (0, utils_1.getLegalStateTransitionPath)(prevState, nextState);
            for (let i = 0; i < path.length - 1; i++) {
                // если нужно корректное предыдущее состояние, то:
                // const oldState = path[i] as LifecycleState
                const currentState = path[i + 1];
                setState(currentState);
            }
        }
    }, []);
    const lifecycleEventHandler = (0, react_1.useCallback)((event) => {
        switch (event.type) {
            case 'pageshow':
            case 'resume': {
                changeState((0, utils_1.getCurrentState)());
                break;
            }
            case 'focus': {
                changeState(enums_1.LifecycleState.ACTIVE);
                break;
            }
            case 'blur': {
                // Событие `blur` может срабатывать во время выгрузки страницы,
                // поэтому нам нужно обновить состояние только в том случае, если текущее состояние «активно».
                if (stateRef.current === enums_1.LifecycleState.ACTIVE) {
                    changeState((0, utils_1.getCurrentState)());
                }
                break;
            }
            case 'pagehide': {
                if (event.persisted) {
                    changeState(enums_1.LifecycleState.FROZEN);
                }
                else {
                    changeState(enums_1.LifecycleState.TERMINATED);
                }
                break;
            }
            case 'visibilitychange': {
                // `visibilityState` у document изменится на "hidden" по мере выгрузки страницы,
                // но в случаях FROZEN и TERMINATED состояние жизненного цикла не должно меняться.
                if (stateRef.current !== enums_1.LifecycleState.FROZEN && stateRef.current !== enums_1.LifecycleState.TERMINATED) {
                    changeState((0, utils_1.getCurrentState)());
                }
                break;
            }
            case 'freeze': {
                changeState(enums_1.LifecycleState.FROZEN);
                break;
            }
        }
    }, [changeState]);
    (0, react_1.useEffect)(() => {
        stateRef.current = state;
    }, [state]);
    (0, react_1.useEffect)(() => {
        consts_1.LIFECYCLE_EVENTS.forEach((type) => {
            window.addEventListener(type, lifecycleEventHandler, { capture: true });
        });
        return () => consts_1.LIFECYCLE_EVENTS.forEach((type) => {
            window.removeEventListener(type, lifecycleEventHandler, { capture: true });
        });
    }, [lifecycleEventHandler]);
    const pageWasDiscarded = (0, react_1.useCallback)(() => (utils_1.isBrowser ? document.wasDiscarded || false : false), []);
    return [state, pageWasDiscarded];
};
exports.usePageLifecycle = usePageLifecycle;
